module.exports = __webpack_public_path__ + "img/alert.4a2db7a0.svg";